<template>
	<el-dialog v-if="dataMissing" :modelValue="open" @update:modelValue="$emit('update:open', $event)" :title="'Angaben fehlen'">
		<el-alert
			:title="'Es wurden noch nicht alle Pflichtfelder ausgefüllt. Bitte vervollständigen Sie den Fall bevor Sie ihn veröffentlichen.'"
			type="error"
			:closable="false"
			effect="dark"
			show-icon
		/>

		<template #footer>
			<div class="button-panel">
				<TheButton type="primary" @buttonclick="$emit('update:open', false)">Bearbeitung fortsetzen</TheButton>
			</div>
		</template>
	</el-dialog>

	<el-dialog
		v-else
		:modelValue="open"
		@update:modelValue="$emit('update:open', $event)"
		:title="shouldPublishCase ? 'Fall veröffentlichen' : 'Veröffentlichung zurückziehen'"
		:before-close="(done) => dialogBeforeClose(done, waiting)"
	>
		<el-alert type="info" effect="dark" :closable="false" show-icon>
			<template #title v-if="shouldPublishCase">
				<p>
					<strong>Durch die Veröffentlichung wird der Fall auf der Website sichtbar.</strong> Sie können die Veröffentlichung jederzeit rückgängig
					machen.
				</p>
			</template>
			<template #title v-else>
				<p>
					<strong>Durch das Zurückziehen der Veröffentlichung wird der Fall von der Website entfernt.</strong> Sie können sie jederzeit wieder
					veröffentlichen.
				</p>
			</template>
		</el-alert>

		<template #footer>
			<div class="button-panel">
				<TheButton type="danger" @buttonclick="handlePublishCase" :disabled="waiting">
					{{ shouldPublishCase ? 'Veröffentlichen' : 'Veröffentlichung zurückziehen' }}
				</TheButton>
				<TheButton type="default" @buttonclick="handleClose">Abbrechen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheButton from '../TheButton.vue';
import TheForm from '../TheForm.vue';

import { publishCase, unpublishCase } from '@/requests/cases';
import { texts } from '../../utils/texts';
import type { FormInstance } from 'element-plus';
import { dialogBeforeClose } from '@/utils/functions';

interface PublishCaseRequest {
	id: string;
	waiting: boolean;
	error: boolean;
	errorMsg: string;
}

export default defineComponent({
	name: 'DialogPublishCase',
	data(): PublishCaseRequest {
		return {
			id: 'publishCaseForm',
			waiting: false,
			error: false,
			errorMsg: texts.cases.publishFailed,
		};
	},
	components: {
		TheButton,
		TheForm,
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		shouldPublishCase: {
			type: Boolean,
			default: true,
			required: true,
		},
		caseId: {
			type: String,
			required: true,
		},
		dataMissing: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const formRef = ref<FormInstance | null>(null);

		return {
			formRef,
		};
	},
	computed: {},
	emits: ['reload', 'update:open'],
	methods: {
		async handlePublishCase() {
			this.waiting = true;
			if (this.shouldPublishCase) {
				const publishResult = await publishCase(this.caseId);

				if (publishResult.success) {
					this.handleClose(true);
				} else {
					this.error = true;
					this.errorMsg = texts.complaints.publishFailed;
				}
			} else {
				const unpublishResult = await unpublishCase(this.caseId);

				if (unpublishResult.success) {
					this.handleClose(true);
				} else {
					this.error = true;
					this.errorMsg = texts.complaints.publishFailed;
				}
			}
			this.waiting = false;
		},
		handleClose(reload: Boolean) {
			this.error = false;
			if (reload) {
				this.$emit('reload');
			}
			this.$emit('update:open', false);
		},
		dialogBeforeClose,
	},
	mounted() {},
});
</script>
